import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import PurchaseOrderForm from './PurchaseOrderForm';
import API_BASE from '../api/baseURL';

export default function SupplierPurchaseOrdersPage() {
  const { token } = useAuth();
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${API_BASE}/users?role=car workshop,spare parts supplier`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        setRecipients(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        setRecipients([]);
        setLoading(false);
      });
  }, [token]);

  return (
    // PurchaseOrderForm carries its own titled panel, so no heading here.
    <div className="max-w-2xl mx-auto p-4">
      {loading
        ? <p className="text-gray-400">Chargement des destinataires…</p>
        : <PurchaseOrderForm users={recipients} />}
    </div>
  );
}
